import * as React from 'react'
import DocumentAcceptanceModal from '../document-acceptance-modal'
import { OnboardingComponentProps } from '.'

export const USLegalDocumentDisclosure: React.FC<OnboardingComponentProps> = React.memo(
  ({ type }) => (
    <DocumentAcceptanceModal
      type={type}
      trackBackgroundCheckSteps={() => null}
    />
  )
)
